module.exports = __webpack_public_path__ + "assets/img/button-Spenden.bc7ff91a.svg";